export enum UserRole {
  SUPER_ADMINISTRATOR = 'SuperAdministrator',
  COMPANY_ADMINISTRATOR = 'CompanyAdministrator',
  TEAM_ADMINISTRATOR = 'TeamAdministrator',
  WORKER = 'Worker',
  PROJECT_CREATOR = 'ProjectCreator',
}
